const DEFINITIONS=Object.freeze([
  Object.freeze({
    key:'smoke_intensity',
    labels:Object.freeze({pl:'Intensywność dymu',en:'Smoke intensity'}),
    options:Object.freeze([
      ['low','Łagodna','Mild'],
      ['medium','Średnia','Medium'],
      ['high','Mocna','Strong']
    ])
  }),
  Object.freeze({
    key:'sweetness',
    labels:Object.freeze({pl:'Słodycz',en:'Sweetness'}),
    options:Object.freeze([
      ['low','Mała','Low'],
      ['medium','Średnia','Medium'],
      ['high','Duża','High']
    ])
  }),
  Object.freeze({
    key:'spiciness',
    labels:Object.freeze({pl:'Pikantność',en:'Spiciness'}),
    options:Object.freeze([
      ['avoid','Unikam','Avoid'],
      ['low','Łagodna','Mild'],
      ['medium','Średnia','Medium'],
      ['high','Ostra','Hot'],
      ['prefer','Lubię wyraźną','Prefer pronounced']
    ])
  }),
  Object.freeze({
    key:'saltiness',
    labels:Object.freeze({pl:'Słoność',en:'Saltiness'}),
    options:Object.freeze([
      ['low','Mała','Low'],
      ['medium','Średnia','Medium'],
      ['high','Duża','High']
    ])
  })
]);

function lang(locale){
  return String(locale||'pl').toLowerCase().startsWith('en')?'en':'pl';
}

export function tastePreferenceDefinitions({locale='pl'}={}){
  const language=lang(locale);
  return Object.freeze(DEFINITIONS.map(def=>Object.freeze({
    key:def.key,
    label:def.labels[language]||def.labels.pl,
    options:Object.freeze(def.options.map(([value,pl,en])=>Object.freeze({
      value,
      label:language==='en'?en:pl
    })))
  })));
}

export function isKnownTastePreference(key){
  return DEFINITIONS.some(def=>def.key===String(key||'').trim().toLowerCase());
}

export function allowedTastePreferenceValues(key){
  const def=DEFINITIONS.find(item=>item.key===String(key||'').trim().toLowerCase());
  return Object.freeze(def?def.options.map(option=>option[0]):[]);
}
